import React from "react"
import { classnames } from "tailwindcss-classnames";

const ROOT_STYLE = classnames(
  'inline-flex',
  'justify-center',
  'items-center',
  'text-center',
  'relative',
  'flex-shrink-0',
  'rounded-full',
  'p-2',
  'transition',
  'ease-in-out',
  'duration-150',
);

interface IconStepProps {
  icon: React.ReactNode;
  label: string;
  isActive?: boolean;
}

const IconStep = ({ icon, label, isActive }: IconStepProps) => {

  const classes = classnames(ROOT_STYLE, {
    'bg-red-500': isActive,
    'bg-gray-300': !isActive,
    'text-white': isActive,
    'text-gray-600': !isActive,
  })

  return (
    <span className={classes}>
      <div
        className={`rounded-full h-12 w-12 flex justify-center items-center`}
      >
        {icon}
      </div>
      <p className="text-sm sr-only">{label}</p>
    </span>
  )
}

export default IconStep
